import { createSlice, createAsyncThunk } from '@reduxjs/toolkit';
import axios from 'axios';
import API_BASE_URL from '../constent';

export const fetchMainTurkishWebsites = createAsyncThunk(
  "websitesTurkish/fetchMainTurkishWebsites",
  async (_, { rejectWithValue }) => {
    try {
      // console.log("heeeeeeeere")
      const response = await axios.get(`${API_BASE_URL}/area/67dfef4a100f542a2c700c04`);
      // console.log(response.data)
      let areaData = response.data.data;
      // Check if superCategory contains only IDs
      if (areaData.category.length > 0) {
        // Fetch all superCategory details in parallel
        const categoryDetails = await Promise.all(
          areaData.category.map(async (item) => {
            if (typeof item.category === "string") {
              const categoryResponse = await axios.get(
                `${API_BASE_URL}/superCategory/${item.category}`
              );
              return { ...item, Category: categoryResponse.data };
            }
            return item;
          })
        );
        // Replace the superCategory array with full objects
        areaData.category = categoryDetails;
        // console.log(areaData)

      }
      // console.log(areaData)
      return areaData.category;
    } catch (error) {
      return rejectWithValue(
        error.response ? error.response.data : "An error occurred"
      );
    }
  }
);


export const fetchWebsitesByIds = createAsyncThunk(
  'websitesTurkish/fetchWebsitesByIds',
  async (ids, { rejectWithValue }) => {
    try {
      const uniqueCategoryIds = [...new Set(ids)];

      const responses = await Promise.allSettled(
        uniqueCategoryIds.map((categoryId) =>
          axios.get(`${API_BASE_URL}/subCategory/${categoryId}`)
        )
      );

      // Filter out successful responses
      const fulfilledResponses = responses
        .filter((res) => res.status === "fulfilled")
        .map((res) => res.value.data);

      return fulfilledResponses;
    } catch (error) {
      return rejectWithValue(
        error.response ? error.response.data : 'An error occurred'
      );
    }
  }
);



// 3. Fetch Notifications Count
export const fetchNotificationsCount = createAsyncThunk(
  'websitesTurkish/fetchNotificationsCount',
  async (_, { rejectWithValue }) => {
    try {
      const response = await axios.get(
        `${API_BASE_URL}/mainTurkishWebsites/get/notifications/counts`,
     
      );
      return response.data;
    } catch (error) {
      return rejectWithValue(
        error.response ? error.response.data : 'An error occurred'
      );
    }
  }
);

// Initial state
const initialState = {
    mainTurkishWebsites: [],
    turkishWebsites: [],
    notificationsCount: null,
    loading: false,
    error: null,
  };
  

// Slice
const websitesSlice = createSlice({
  name: 'websitesTurkish',
  initialState,
  reducers: {
    clearError: (state) => {
      state.error = null;
    },
    clearNotificationsCount: (state) => {
      state.notificationsCount = null;
    },
    clearWebsites: (state) => {
      state.mainTurkishWebsites = [];
      state.turkishWebsites = [];
    },
  },
  extraReducers: (builder) => {
    builder
      // Fetch Main Turkish Websites
      .addCase(fetchMainTurkishWebsites.pending, (state) => {
        state.loading = true;
        state.error = null;
      })
      .addCase(fetchMainTurkishWebsites.fulfilled, (state, action) => {
        state.loading = false;
        state.mainTurkishWebsites = action.payload;
      })
      .addCase(fetchMainTurkishWebsites.rejected, (state, action) => {
        state.loading = false;
        state.error = action.payload;
      })


      // Fetch Notifications Count
      .addCase(fetchNotificationsCount.pending, (state) => {
        state.loading = true;
        state.error = null;
      })
      .addCase(fetchNotificationsCount.fulfilled, (state, action) => {
        state.loading = false;
        state.notificationsCount = action.payload;
      })
      .addCase(fetchNotificationsCount.rejected, (state, action) => {
        state.loading = false;
        state.error = action.payload;
      });
  },
});

// Export actions and reducer
export const { clearError, clearNotificationsCount, clearWebsites } = websitesSlice.actions;
export default websitesSlice.reducer;
